import { useCallback, useEffect } from 'react';
import useBlockOperationDialog from './useBlockOperationDialog';
import useOperationBlockStatus from './useOperationBlockStatus';
import { OPERATION_AVAILABILITY_STATUS as STATUS } from '../constants/factoring/operation-availability-status';

/**
 * Verifica la disponibilidad de las operaciones antes de avanzar.
 *
 * El clic solo dispara la consulta. Cuando el estado pasa a un resultado
 * (AVAILABLE, BLOCKED o ERROR) un efecto decide: avanzar si está disponible o abrir
 * el pop up si hay bloqueo o error. En IDLE (aún sin consultar) y CHECKING
 * (consulta en curso) no se hace nada.
 */
const useOperationAvailabilityAction = (handleConfirmation) => {
  const {
    status,
    isBlocked,
    unavailabilityCode,
    getAreOperationsAvailable,
  } = useOperationBlockStatus();

  const {
    handleShowConfirmationSummary,
    blockOperationDialogProps,
  } = useBlockOperationDialog(handleConfirmation, isBlocked);

  const handleActionClick = useCallback(() => {
    if (status === STATUS.CHECKING) return;
    getAreOperationsAvailable();
  }, [status, getAreOperationsAvailable]);

  useEffect(() => {
    if (status === STATUS.IDLE || status === STATUS.CHECKING) return;
    handleShowConfirmationSummary(true);
  }, [status, handleShowConfirmationSummary]);

  return {
    isBlocked,
    unavailabilityCode,
    blockOperationDialogProps,
    handleActionClick,
    handleShowConfirmationSummary,
  };
};

export default useOperationAvailabilityAction;
